import { useContext } from "react";

import { ThemeContext } from "../providers";

export const useTheme = () => {
  const context = useContext(ThemeContext);
  return context;
};
